export default {
	title: 'نسبة زيارات المناطق',
	'incomplete-visits-banner': 'لديك ({count}) زيارات غير منجزة خلال يوم: {date}',
	visited: 'تمت زيارتهم',
	'not-visited': 'لم يزار',
	'unknown-customer': 'زبون غير معروف',
	'no-statistics': 'لا توجد إحصائيات لهذا اليوم',
}
